import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function AdminResearchPapers() {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate=useNavigate();
  /* 🔹 Fetch all research papers (ADMIN) */
  const fetchPapers = async () => {
    try {
      const res = await api.get("/api/research-papers/admins/all");
      setPapers(res.data || []);
    } catch (err) {
      console.error("Error fetching research papers", err);
    } finally {
      setLoading(false);
    }
  };
const stripHtml = (html) => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

  useEffect(() => {
    fetchPapers();
  }, []);

  /* ✅ ACCEPT = UPDATE STATUS */
  const approvePaper = async (id) => {
    try {
      await api.put(
        `/api/research-papers/admins/updatestatus/${id}`,
        null,
        { params: { status: "APPROVED" } }
      );

      // update UI instantly
      setPapers((prev) =>
        prev.map((p) =>
          p.id === id ? { ...p, status: "APPROVED" } : p
        )
      );
    } catch (err) {
      console.error("Approve failed", err);
      alert("Failed to approve paper");
    }
  };

  /* ❌ REJECT = DELETE FROM DB */
  const rejectAndDeletePaper = async (id) => {
    const confirmDelete = window.confirm(
      "Rejecting will permanently delete this research paper. Continue?"
    );

    if (!confirmDelete) return;

    try {
      await api.delete(`/api/research-papers/admins/delete/${id}`);

      // remove from UI
      setPapers((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Delete failed", err);
      alert("Failed to delete research paper");
    }
  };

  if (loading) return <p>Loading research papers...</p>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4">📚 Research Papers (Admin)</h2>

      {papers.length === 0 && <p>No research papers found.</p>}

      <div className="row">
        {papers.map((paper) => (
          <div className="col-md-4 mb-4" key={paper.id}>
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">{paper.title}</h5>

                <p className="text-muted mb-1">
                  <strong>Posted By:</strong> {paper.postedByEmail}
                </p>

                <p className="text-muted mb-1">
                  <strong>User Type:</strong> {paper.postedByType}
                </p>

                <p className="mb-2">
                  <strong>Status:</strong>{" "}
                  <span
                    className={`badge ${
                      paper.status === "APPROVED"
                        ? "bg-success"
                        : paper.status === "PENDING"
                        ? "bg-warning"
                        : "bg-secondary"
                    }`}
                  >
                    {paper.status}
                  </span>
                </p>

                <p className="card-text">
                 {paper.abstractText
  ? stripHtml(paper.abstractText).slice(0, 120) + "..."
  : "No abstract"}

                </p>
              </div>

              <div className="card-footer bg-white d-flex justify-content-between">
                <button
                  className="btn btn-success btn-sm"
                  disabled={paper.status === "APPROVED"}
                  onClick={() => approvePaper(paper.id)}
                >
                  Accept
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => rejectAndDeletePaper(paper.id)}
                >
                  Reject  
                </button>
                <button
  className="btn btn-outline-primary btn-sm"
  onClick={() => navigate(`/admin/researchadmin/edit/${paper.id}`)}
>
  View & Update
</button>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
